/*
 * File: en-US.ts
 * File Created: 2023-12-05 02:19:57
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-09 10:53:53
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { RegisterBaseLanguage } from "./core";

@RegisterBaseLanguage("en-US", "English")
export default class LangObject {
    /// generic terms //////////////////
    w_Description = "Description";
    w_Email = "Email";
    w_Name = "Name";
    w_Username = "Username";
    w_Password = "Password";
    w_Index = "Index";
    w_Date = "Date";
    w_Id = "ID";
    w_Age = "Age";
    w_CreatedAt = "Created At";
    w_UpdatedAt = "Updated At";
    w_BeginAt = "Start Date";
    w_EndAt = "End Date";
    w_Image = "Image";
    w_Yes = "Yes";
    w_No = "No";
    w_On = "On";
    w_Off = "Off";
    w_Reload = "Reload";
    w_Unknown = "Unknown";
    w_Menu = "Menu";
    w_Home = "Home";
    w_Loading = "Loading";
    w_Detail = "Detail";
    w_Role = "Role";
    w_RolePermission = "Role Permission";
    w_IsEnabled = "Enabled";
    w_Log = "Log";
    w_Priority = "Priority";
    w_Category = "Category";
    w_ErrorMessage = "Error Message";
    w_OtherMessage = "Other Message";
    w_System = "System";
    w_Status = "Status";
    w_NICs = "Network Interfaces";
    w_Manufacturer = "Manufacturer";
    w_Brand = "Brand";
    w_Speed = "Speed";
    w_Cores = "Cores";
    w_PhysicalCores = "Physical Cores";
    w_Memory = "Memory";
    w_Disks = "Disks";
    w_Device = "Device";
    w_Type = "Type";
    w_SerialNumber = "Serial Number";
    w_Actions = "Actions";

    w_Common = "Common";
    w_NextPage = "Next";
    w_PreviousPage = "Prev";
    w_Search = "Search";
    w_Browse = "Browse";
    w_NextStep = "Next";
    w_PreviousStep = "Previous";
    w_Done = "Done";
    w_Save = "Save";
    w_Test = "Test";
    w_Success = "Success";
    w_Error = "Error";
    w_Language = "Language";
    w_Title = "Title";
    w_Every = "Every";
    w_EveryMonth = "Every month";

    w_Login = "Login";
    w_Logout = "Logout";
    w_NewPassword = "New Password";
    w_ConfirmChangePassword = "Change Password?";
    w_LoginFailed = "Login Failed.";

    w_Add = "Add";
    w_Delete = "Delete";
    w_Edit = "Edit";
    w_Export = "Export";
    w_Import = "Import";
    w_Info = "Info";
    w_View = "View";
    w_More = "More";

    w_Submit = "Submit";
    w_Reset = "Reset";
    w_Undo = "Undo";

    w_Confirm = "Confirm";
    w_Cancel = "Cancel";
    w_Close = "Close";
    w_ReLogin = "Sign in again";
    w_Back = "Back";
    w_Finish = "Finish";

    w_Upload = "Upload";
    w_Change = "Change";
    w_Remove = "Remove";
    w_Abort = "Abort";
    w_Retry = "Retry";

    w_Second = "Second";
    w_Minute = "Minute";
    w_Hour = "Hour";
    w_Day = "Day";
    w_Month = "Month";
    w_Year = "Year";

    w_Online = "Online";
    w_Offline = "Offline";

    w_Enabled = "Enabled";
    w_Disabled = "Disabled";

    // datetime
    w_Weekday = "Weekday";
    w_Time = "Time";
    w_DateTime_ShortWeekDay0 = "Sun";
    w_DateTime_ShortWeekDay1 = "Mon";
    w_DateTime_ShortWeekDay2 = "Tue";
    w_DateTime_ShortWeekDay3 = "Wed";
    w_DateTime_ShortWeekDay4 = "Thu";
    w_DateTime_ShortWeekDay5 = "Fri";
    w_DateTime_ShortWeekDay6 = "Sat";

    w_DateTime_NormalWeekDay0 = "Sunday";
    w_DateTime_NormalWeekDay1 = "Monday";
    w_DateTime_NormalWeekDay2 = "Tuesday";
    w_DateTime_NormalWeekDay3 = "Wednesday";
    w_DateTime_NormalWeekDay4 = "Thursday";
    w_DateTime_NormalWeekDay5 = "Friday";
    w_DateTime_NormalWeekDay6 = "Saturday";

    w_DateTime_ShortMonth01 = "Jan";
    w_DateTime_ShortMonth02 = "Feb";
    w_DateTime_ShortMonth03 = "Mar";
    w_DateTime_ShortMonth04 = "Apr";
    w_DateTime_ShortMonth05 = "May";
    w_DateTime_ShortMonth06 = "Jun";
    w_DateTime_ShortMonth07 = "Jul";
    w_DateTime_ShortMonth08 = "Aug";
    w_DateTime_ShortMonth09 = "Sep";
    w_DateTime_ShortMonth10 = "Oct";
    w_DateTime_ShortMonth11 = "Nov";
    w_DateTime_ShortMonth12 = "Dec";

    w_DateTime_NormalMonth01 = "January";
    w_DateTime_NormalMonth02 = "February";
    w_DateTime_NormalMonth03 = "March";
    w_DateTime_NormalMonth04 = "April";
    w_DateTime_NormalMonth05 = "May";
    w_DateTime_NormalMonth06 = "June";
    w_DateTime_NormalMonth07 = "July";
    w_DateTime_NormalMonth08 = "August";
    w_DateTime_NormalMonth09 = "September";
    w_DateTime_NormalMonth10 = "October";
    w_DateTime_NormalMonth11 = "November";
    w_DateTime_NormalMonth12 = "December";

    w_DateTime_AM = "am";
    w_DateTime_PM = "pm";
    ////////////////////////////////////

    /// for component used mb, put inside this block /////
    // iv-table
    w_ShowEntries = "Show {0} Entries";
    w_ShowCurrentEntries = "Showing {curStart} to {curEnd} of {total} entries";
    w_NoDataAvailable = "No Data Available";
    w_ConnectionError = "Connection Error";
    // iv-table-cell
    w_CellNullText = "N/A";
    // iv-input-file-classic
    w_IFCNoFileChosen = "No File Chosen";
    // iv-input-tree-select
    w_PleaseSelect = "Please Select";
    w_InputTreeSelectNoAvailable = "No Available Options";
    // iv-input-file
    w_InputFileAddNew = "New File";
    w_InputFileNoFile = "No File";
    w_InputFileNotImageHint = "Normal File";
    w_InputFileSelect = "Select File";
    w_InputFileHint = "Drag & Drop your files or {0}Browse{1}";
    w_InputFileInvalidField = "Field contains invalid files";
    w_InputFileWaitingForSize = "Waiting for size";
    w_InputFileSizeNotAvailable = "Size not available";
    w_InputFileLoadError = "Error during load";
    w_InputFileUploading = "Uploading";
    w_InputFileUploadComplete = "Upload complete";
    w_InputFileUploadAborted = "Upload cancelled";
    w_InputFileUploadError = "Error during upload";
    w_InputFileRevertError = "Error during revert";
    w_InputFileRemoveError = "Error during remove";
    w_InputFileTapToCancel = "Tap to cancel";
    w_InputFileTapToRetry = "Tap to retry";
    w_InputFileTapToUndo = "Tap to undo";
    // iv-input-cron
    w_InputCronPlaceholder = "Please select timing strategy";
    w_InputCronSecondEvery = "Every second";
    w_InputCronSecondCriteria = "Starting at {0} second, every {0} second(s)";
    w_InputCronSecondSpecific = "Specific seconds {0}";
    w_InputCronSecondBetween = "Every second between {0} and {1}";
    w_InputCronMinuteEvery = "Every minute";
    w_InputCronMinuteCriteria = "Starting at {0} minute, every {1} minute(s)";
    w_InputCronMinuteSpecific = "Specific minutes {0}";
    w_InputCronMinuteBetween = "Every minute between {0} and {1}";
    w_InputCronHourEvery = "Every hour";
    w_InputCronHourCriteria = "Starting at {0} hour, every {1} hour(s)";
    w_InputCronHourSpecific = "Specific hours {0}";
    w_InputCronHourBetween = "Every hour between {0} and {1}";
    w_InputCronDayEvery = "Every day";
    w_InputCronDayCriteria = "Starting at the {0} of the month, every {1} day(s)";
    w_InputCronDayOfWeek = "Specific day of week {0}";
    w_InputCronDayOfMonth = "Specific day of month {0}";
    w_InputCronDayLastDayOfMonth = "On the last day of the month";
    w_InputCronDayLastWeekdayOfMonth = "On the last weekday of the month";
    w_InputCronDayLastDayOfWeek = "On the last {0} of the month";
    w_InputCronDayBeforeLastDayOfMonth = "{0} day(s) before the end of the month";
    w_InputCronDayNearestWeekday =
        "Nearest weekday (Monday to Friday) to the {0} of the month";
    w_InputCronDayNumberedDayOfWeek = "On the {0}'s {1} of the month";
    w_InputCronMonthEvery = "Every month";
    w_InputCronMonthCriteria = "Starting in {0}, every {0} month(s)";
    w_InputCronMonthSpecific = "Specific months {0}";
    w_InputCronMonthBetween = "Every month between {0} and {1}";
    w_InputCronYearEvery = "Every year";
    w_InputCronYearCriteria = "Starting in {0}, every {0} year(s)";
    w_InputCronYearSpecific = "Specific years {0}";
    w_InputCronYearBetween = "Every year between {0} and {1}";
    w_InputCronReadTextYear = "{0}";
    w_InputCronReadTextMonth = "{0} month(s)";
    w_InputCronReadTextDay = "{0}th";
    w_InputCronReadTextHour = "{0} hour(s)";
    w_InputCronReadTextMinute = "{0} minute(s)";
    w_InputCronReadTextSecond = "{0} second(s)";
    w_InputCronReadTextYearSp = "Special year(s)";
    w_InputCronReadTextMonthSp = "Special month(s)";
    w_InputCronReadTextDaySp = "Special day(s)";
    w_InputCronReadTextHourSp = "Special hour(s)";
    w_InputCronReadTextMinuteSp = "Special minute(s)";
    w_InputCronReadTextSecondSp = "Special second(s)";
    w_InputCronReadTextYearEvery = "Every year";
    w_InputCronReadTextMonthEvery = "Every month";
    w_InputCronReadTextHourEvery = "Every hour";
    w_InputCronReadTextMinuteEvery = "Every minute";
    w_InputCronReadTextSecondEvery = "Every second";
    w_InputCronReadTextDayEvery = "Every day";
    w_InputCronReadTextMonthOdd = "Odd months";
    w_InputCronReadTextMonthEven = "Even months";
    // iv-input-table
    w_InputTableConfirmDelete = "Data Deletion Confirmation";
    w_InputTableConfirmDeleteMessage = "Are you sure to delete?";

    // iv-form
    w_RequiredField = "This is a required field.";
    // iv-form-file
    w_FileExceedLimit = "File size exceeds limit ({limit})";
    // iv-form-password
    w_RequireValidPassword =
        "Min {length} characters with uppercase, lowercase, and a symbol.";
    // iv-form-square-meter
    w_SquareMeter = "Square Meter";
    w_Tsubo = "Tsubo";

    // ui-validate-unique
    w_FormUniqueStringValidating = "Validating...";
    w_FormUniqueStringValidated = "Verification passed";
    w_FormUniqueStringBeenUsed = `"{0}" has already been used`;
    // ui-validate-email
    w_RequireValidEmailFormat = "Please enter the correct email format.";
    // ui-validate-ip
    w_RequireValidIPFormat = "Please enter the correct IP format.";
    // ui-form-quick-table
    w_AutofillAfterCreate = "Auto-fill after creation";

    // http alert
    w_StatusUnknown = "Request Failed";
    w_StatusUnknown_Message = "No response from server.";
    w_Status400 = "Bad Request";
    w_Status400_Message =
        "Server cannot process request due to client error. Check your parameters sent with request.";
    w_Status401 = "Authorization invalid / Connection timed out";
    w_Status401_Message =
        "We can’t verify your identity, or the connection has timed out. Please sign in again to continue.";
    w_Status403 = "Permission Denied";
    w_Status403_Message = "Permission required to request this page.";
    w_Status404 = "Not Found";
    w_Status404_Message = "This resource cannot be accessed.";
    w_Status422 = "Unprocessable";
    w_Status422_Message =
        "The request format is correct, but the server cannot process it due to semantic errors. Please check the completeness or accuracy of the input information.";
    w_Status500 = "Internal Server Error";
    w_Status500_Message = "Unknown server error.";
    /////////////////////////////////////////////////////

    w_FormMultipleClickToAdd = "Click to Add";

    w_VersionLimitation = "Version Limitation";
    w_VersionNotEnough = "ServerFramework version should be greater than v{version}.";
    w_PermissionDenied = "Permission Denied";
    w_PermissionDeniedLong = "Your Permission Cannot Access This Area.";
    w_ContentInvalid = "Content Invalid";

    w_ConfirmDelete = "Are you sure to delete?";
    w_FormSelectionNoResult = "No Available Options";
    w_NoFileChosen = "No File Chosen";

    /// validation message
    w_ValidateRequireConsent = "Consent is required to continue.";
    w_ValidateRange = "(range: {min}-{max})";
    w_ValidateRangePercent = "(range: {min}-{max}%)";
    w_ValidationIp = "Please input valid IP format.";
    w_ValidationLicense = "Please input valid license format.";
    w_ValidationNumber = "Number should between {min} and {max}.";
    w_ValidationEmail = "Please input valid email format.";
    w_ValidationImageFile =
        "File Type must be .jpg / .jpeg / .png / .bmp. File Size must be less than {0} MB";

    /// form-datetime
    w_Date_Not_Selected = "No date selected";
    w_Time_Not_Selected = "No time selected";

    /// theme
    w_VAL_Theme_White = "White";
    w_VAL_Theme_Blue = "Blue";

    /// quick
    w_QuickList_ListItem = "{0} List";
    w_QuickList_CreateItem = "Create {0}";
    w_QuickList_EditItem = "Edit {0}";
    w_QuickList_DeleteItem = "Delete {0}";
    w_QuickList_TableEmpty = "No {0}";
    w_QuickList_Goto = "Goto";
    w_QuickDetail_Title = "{0} Details";
    w_QuickDetail_ShowSimple = "Simple";
    w_QuickDetail_ShowDetail = "Detail";

    w_QuickCreate_BasicInformation = "Basic Information";
    w_QuickCreate_UpdateInformation = "Update Information";
}
